<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              placeholder="中转策略名称/客户名称/始发地目的地(省份/城市/区县)搜索..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              v-allow="'actAdd'"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="
                openEditPage({
                  pageType: 'add'
                })
              "
            >
              <b-icon-plus></b-icon-plus>新增
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form">
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="策略名称">
              <el-input
                v-model.trim="form.transferRuleName"
                placeholder="请输入中转策略名称"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="策略类型">
              <el-select
                v-model="form.transferRuleType"
                placeholder="请选择中转策略类型"
                clearable
                size="small"
                style="width:100%"
              >
                <el-option label="一键中转策略" value="A"></el-option>
                <el-option label="指定中转策略" value="B"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="组织机构">
              <org-cascader
                :lastValue.sync="form.orgCode"
                placeholder="请选择组织机构"
              />
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="客户">
              <dict-select
                filterable
                clearable
                v-model="form.custCode"
                url="/master/customer/info/select"
                placeholder="请选择客户"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="目的地">
              <el-input
                v-model.trim="form.destination"
                placeholder="请输入目的地"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="始发地">
              <el-input
                v-model.trim="form.originPlace"
                placeholder="请输入始发地"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="始发地省份">
              <el-input
                v-model.trim="form.originProvinceName"
                placeholder="请输入始发地省份"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="目的地省份">
              <el-input
                v-model.trim="form.destinationProvinceName"
                placeholder="请输入目的地省份"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="始发地城市">
              <el-input
                v-model.trim="form.originCityName"
                placeholder="请输入始发地城市"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="目的地城市">
              <el-input
                v-model.trim="form.destinationCityName"
                placeholder="请输入目的地城市"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="始发地区县">
              <el-input
                v-model.trim="form.originDistrictName"
                placeholder="请输入始发地区县"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="目的地区县">
              <el-input
                v-model.trim="form.destinationDistrictName"
                placeholder="请输入目的地区县"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="创建人名字">
              <el-input
                v-model.trim="form.createByName"
                placeholder="请输入创建人名字"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="修改人名字">
              <el-input
                v-model.trim="form.modifyByName"
                placeholder="请输入修改人名字"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="margin-top:8px">
          <el-form-item label="创建时间">
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 10 }">
              <el-date-picker
                v-model="form.createBeginDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="请选择创建时间"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="1">-</el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 10 }">
              <el-date-picker
                v-model="form.createEndDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="请选择创建时间"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>

        <el-row style="margin-top:8px">
          <el-form-item label="修改时间">
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 10 }">
              <el-date-picker
                v-model="form.modifyBeginDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="请选择修改时间"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="1">-</el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 10 }">
              <el-date-picker
                v-model="form.modifyEndDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="请选择修改时间"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="状态">
            <el-checkbox-group v-model="form.transferRuleStatusList">
              <el-checkbox label="Y">有效</el-checkbox>
              <el-checkbox label="N">无效</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  transferRuleStatusList: ['Y']
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm }
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 打开编辑页面
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'master-transferRule-detail',
        params: { ...params, pageType }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
